export const ControllerReportState: { [key: string]: number } = {
       WAITING: 0,
       SELECTED: 1,
       PLANNED: 2,
       DONE: 3,
       VALIDATE: 4,
       REJECTED: 5,
};

export const UserProfile  = () => {
       const userInfo = useCookie('UserInfo').value as any;
       if (!userInfo){
              navigateTo('/login');
              return null;
       };
       return userInfo.user;
}